<template>
  <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 p-0 mb-3 columns">
    <div class="card m-2 p-0 align-items-stretch rounded rounded-pill">
      <div class="position-absolute top-0 start-50 translate-middle">
        <div
          class="text-black position-absolute top-0 start-0 translate-middle bg-white btn-sm btn-white rounded-pill border border-2 p-0 px-2"
          style="width: auto; height: auto; font-size: 16px"
        >
          0
        </div>
      </div>

      <div class="bg-secondary rounded-bottom rounded-pill p-3 pt-3 pb-2">
        <span class="text-center text-white">Loading...</span>
      </div>

      <!-- <img :src="img" class="card-img-top" alt="..." /> -->

      <div class="card-body p-0 m-0 mt-1">
        <!-- <p class="card-text">jakies info dodatkowe można tutaj dać</p> -->
      </div>
      <h5 class="card-title p-0 m-3 mt-3 mb-5">Loading...</h5>
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Loading...</li>
        <li class="list-group-item">
          Loading...
          <span class="badge rounded-pill bg-secondary ms-1">24h</span>
        </li>
        <li class="list-group-item">
          Loading...
          <span class="badge rounded-pill bg-secondary ms-1">24h</span>
        </li>
        <li class="list-group-item text-black p-3">
          <!-- change to white ^^ -->Loading...
          <span class="badge rounded-pill bg-white text-success ms-1"></span>
        </li>
        <!-- <li :class="list-group-item bg-success text-white p-3">{{ message }}<span class="badge rounded-pill bg-white text-success ms-1">dziennie</span></li> -->
      </ul>
      <div class="p-1 py-3 bg-white rounded-3 rounded-top rounded-pill">
        <a target="_blank" class="card-link h5">Loading...</a>
        <br />
        <!-- <a href="#" class="card-link">Pokaż specyfikację</a> -->
      </div>
    </div>
  </div>
</template>

<style scoped>
.columns {
  display: flex;
  align-items: stretch;
}
</style>
